if (!customElements.get('product-size-guide')) {
  class ProductSizeGuide extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;

      this.openButton = this.querySelector(
        '[data-size-guide-open]'
      );

      this.dialog = this.querySelector(
        '[data-size-guide-dialog]'
      );

      this.closeButton = this.querySelector(
        '[data-size-guide-close]'
      );

      if (!this.openButton || !this.dialog) return;

      this.mountTriggerBesideSize();
      this.bindEvents();
    }


    /*
     * Move "Size Guide" beside the Size variant heading.
     */
    mountTriggerBesideSize() {
      if (!this.openButton) return;

      const section =
        document.getElementById(
          `shopify-section-${this.dataset.sectionId}`
        ) ||
        this.closest('.shopify-section') ||
        document;

      const groups = Array.from(
        section.querySelectorAll(
          'fieldset.product-form__input, .product-form__input'
        )
      );

      const sizeGroup = groups.find((group) => {
        const label = group.querySelector(
          'legend, .form__label'
        );

        const text =
          label?.textContent
            ?.trim()
            .toLowerCase() || '';

        return (
          text === 'size' ||
          text.includes('size')
        );
      });

      /*
       * If no Size variant exists,
       * leave the Size Guide button where Liquid rendered it.
       */
      if (!sizeGroup) return;

      const originalLabel = sizeGroup.querySelector(
        'legend, .form__label'
      );

      if (!originalLabel) return;

      sizeGroup.classList.add(
        'mmn-size-guide__variant-group'
      );

      originalLabel.classList.add(
        'mmn-size-guide__original-label--hidden'
      );

      let header = sizeGroup.previousElementSibling;

      /*
       * Create a separate heading row:
       *
       * Size                         Size Guide
       */
      if (
        !header ||
        !header.classList.contains(
          'mmn-size-guide__variant-header'
        )
      ) {
        header = document.createElement('div');

        header.className =
          'mmn-size-guide__variant-header';

        sizeGroup.parentNode.insertBefore(
          header,
          sizeGroup
        );
      }

      let title = header.querySelector(
        '.mmn-size-guide__variant-title'
      );

      if (!title) {
        title = document.createElement('span');

        title.className =
          'mmn-size-guide__variant-title';

        title.textContent =
          originalLabel.textContent.trim() || 'Size';

        header.appendChild(title);
      }

      this.openButton.classList.add(
        'mmn-size-guide__trigger--inline'
      );

      header.appendChild(this.openButton);

      this.classList.add(
        'mmn-size-guide--trigger-mounted'
      );
    }


    /*
     * Modal events
     */
    bindEvents() {

      /*
       * OPEN
       */
      this.openButton.addEventListener(
        'click',
        () => {
          if (
            typeof this.dialog.showModal ===
            'function'
          ) {
            this.dialog.showModal();

            this.openButton.setAttribute(
              'aria-expanded',
              'true'
            );

            document.body.classList.add(
              'mmn-size-guide-is-open'
            );
          }
        }
      );


      /*
       * CLOSE BUTTON
       */
      this.closeButton?.addEventListener(
        'click',
        () => {
          this.closeDialog();
        }
      );


      /*
       * CLICK OUTSIDE PANEL
       */
      this.dialog.addEventListener(
        'click',
        (event) => {
          if (event.target === this.dialog) {
            this.closeDialog();
          }
        }
      );


      /*
       * ESC is handled natively by <dialog>,
       * but we clean up states after it closes.
       */
      this.dialog.addEventListener(
        'close',
        () => {
          this.openButton.setAttribute(
            'aria-expanded',
            'false'
          );

          document.body.classList.remove(
            'mmn-size-guide-is-open'
          );

          this.openButton.focus();
        }
      );


      /*
       * Handle native cancel / ESC consistently.
       */
      this.dialog.addEventListener(
        'cancel',
        () => {
          document.body.classList.remove(
            'mmn-size-guide-is-open'
          );
        }
      );
    }


    closeDialog() {
      if (
        this.dialog &&
        this.dialog.open
      ) {
        this.dialog.close();
      }
    }
  }


  customElements.define(
    'product-size-guide',
    ProductSizeGuide
  );
}